export const initialPurchaseOrderInformation = {
  currency: '',
  paymentTermId: '',
  paymentMethod: '',
  paymentOptions: '',
  fulfilledAmount: null,
  status: 'Open',
  notes: '',
  priceSheetId: '',
  order: {
    effectiveDate: null,
    expirationDate: null,
    packageType: '',
    pickupDelivery: '',
    receivingYard: '',
  },
  supplier: {},
  customerSONumber: '',
  purchaseOrderLocationId: '',
  docs: [],
}

export const initialSalesOrderInformation = {
  currency: '',
  paymentTermId: '',
  paymentMethod: '',
  paymentOptions: '',
  fulfilledAmount: null,
  status: 'Open',
  notes: '',
  priceSheetId: '',
  orderSalesDetails: {
    effectiveDate: null,
    expirationDate: null,
    packageType: '',
    departingYard: '',
    fairOnBoard: '',
    invoiceWeights: '',
  },
  customer: {},
  customerPONumber: '',
  salesOrderLocationId: '',
  freightDestination: {
    customerName: '',
    customerId: '',
    locationId: '',
    locationName: '',
    address: '',
    city: '',
    state: '',
    zip: '',
  },
  freightPricing: {
    consumerFreightCost: null,
    consumerFreightChargeback: null,
    consumerFreightEnabled: false,
    consumerFreightNegativeChargeback: false,
  },
  docs: [],
  showNotesOnBOL: false,
}

/**
 * Check if there are any materials with override names for a transfer
 * @param isTransfer
 * @param materials
 * @returns {{data: {error: string}}|boolean}
 */
export const getOverrideNameTransferError = (isTransfer, materials) => {
  if (!isTransfer) return false
  const overrideNameTransferError = Object.values(materials).some(material => Boolean(material.overrideName))
  if (overrideNameTransferError) {
    return {
      data: {
        error: 'Transfers cannot have override names',
      },
    }
  }
  return false
}

/**
 * Check if there are duplicated materials with missing override names
 * @param materials
 * @returns {boolean|{data: {error: string}}}
 */
export const getDuplicateOverrideNameError = materials => {
  const materialCounts = {}
  materials.forEach(material => {
    if (!materialCounts[material.materialTypeId]) {
      materialCounts[material.materialTypeId] = {
        numberOfDuplicates: 0,
        missingOverrideName: 0,
      }
    }
    materialCounts[material.materialTypeId].numberOfDuplicates += 1
    if (!material.overrideName) {
      materialCounts[material.materialTypeId].missingOverrideName += 1
    }
  })

  const overrideNameError = Object.values(materialCounts).some(
    count => count.numberOfDuplicates > 1 && count.missingOverrideName > 0,
  )

  if (overrideNameError) {
    return {
      data: {
        error: 'Every duplicated material must have an override name',
      },
    }
  }

  return false
}
